import { Component, OnDestroy, OnInit } from '@angular/core';
import { ClientsModel } from '@modules/api/clients-model.generated';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CurrentCaseService } from '@modules/common/services/current-case.service';
import { CachedCaseListService } from '@modules/common/services/cached-case-list.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-nav-client-picker',
    templateUrl: './nav-client-picker.component.html',
    styleUrls: ['./nav-client-picker.component.scss']
})
export class NavClientPickerComponent implements OnInit, OnDestroy {
    public clients?: ClientsModel[];
    public selectedClientName!: string;
    public form!: FormGroup;

    private _valueChangesSubscription?: Subscription;
    private _cachedCaseListChangedSubscription?: Subscription;

    constructor(
        private _cachedCaseListService: CachedCaseListService,
        private _formBuilder: FormBuilder,
        private _currentCaseService: CurrentCaseService
    ) { }

    public ngOnInit(): void {
        this.form = this._formBuilder.group({
            clientName: [this._currentCaseService.getCurrentCaseName() || ''],
        });

        this._valueChangesSubscription = this.form.valueChanges.subscribe(() => {
            this._currentCaseService.setCurrentCase(this.form.get('clientName')!.value);
        })

        this._cachedCaseListChangedSubscription = this._cachedCaseListService.cachedCaseListChanged.subscribe(result => {
            this.clients = result;
            if (this.clients && this.clients.length == 1 && this.clients[0].clientCode != this._currentCaseService.getCurrentCaseName()) {
                this._currentCaseService.setCurrentCase(this.clients[0].clientCode || '');
            } else if (this._currentCaseService.getCurrentCaseName() && !this.clients.some(x => x.clientCode == this._currentCaseService.getCurrentCaseName())) {
                this._currentCaseService.setCurrentCase('');
            }
        });
    }

    public ngOnDestroy(): void {
        this._valueChangesSubscription?.unsubscribe();
        this._cachedCaseListChangedSubscription?.unsubscribe();
    }
}